export enum Log {
  Startup = 'Startup',
  Log = 'Log',
  Important = 'Important'
}

export class Logger {
  log(type: Log, data: { message?: string; data?: Record<string, unknown> }): void {
    const colorMap: Record<Log, string> = {
      [Log.Startup]: 'color: #66b3ff',
      [Log.Log]: 'color: #5a31f4',
      [Log.Important]: 'color: #ff4d4f'
    };

    console.log(`%c${data?.message}${this.parsePayloadToMessage(data?.data)}`, colorMap[type]);
  }

  private parsePayloadToMessage(data: Record<string, unknown> | undefined): string {
    return data ? `: \n${JSON.stringify(data)}` : '';
  }
}
